import { render, staticRenderFns } from "./Correspondencia2.vue?vue&type=template&id=7a2fd3ca&scoped=true&"
import script from "./Correspondencia2.vue?vue&type=script&lang=js&"
export * from "./Correspondencia2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2fd3ca",
  null
  
)

export default component.exports